<template>
  <ToolbarDropdown ref="dropdownRef" align="right" width="180px" @open="emit('open')">
    <template #button>
      <button class="actions-trigger" aria-haspopup="true">
        <font-awesome-icon icon="ellipsis-v" />
      </button>
    </template>
    <template v-for="item in items" :key="item.key">
      <hr v-if="item.separator" class="dropdown-divider" />
      <a
        v-tooltip="item.tooltip"
        class="dropdown-item flex items-center g-2"
        :class="{
          'is-disabled': item.disabled,
          'is-active': item.isActive,
          'has-tooltip': !!item.tooltip,
        }"
        @click="handleClick(item)"
      >
        <span class="icon is-small text-muted">
          <font-awesome-icon :icon="item.icon" />
        </span>
        <span class="mr-4">{{ item.label }}</span>
      </a>
    </template>
  </ToolbarDropdown>
</template>

<script setup lang="ts">
import { ref } from "vue"
import ToolbarDropdown from "./ToolbarDropdown.vue"

export interface ActionItem {
  key?: string
  label?: string
  icon?: string | string[]
  separator?: boolean
  disabled?: boolean
  /** Why the item is disabled, shown on hover. */
  tooltip?: string
  isActive?: boolean
}

defineProps<{
  items: ActionItem[]
}>()

const emit = defineEmits<{
  action: [key: string]
  /** The menu opened: a caller can refresh what its items show. */
  open: []
}>()

const dropdownRef = ref<InstanceType<typeof ToolbarDropdown> | null>(null)

function handleClick(item: ActionItem) {
  if (item.disabled) return
  emit("action", item.key as string)
  dropdownRef.value?.close()
}
</script>

<style>
.dropdown-item.is-disabled.has-tooltip {
  pointer-events: auto;
  cursor: not-allowed;
}

.actions-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: var(--auger-radius);
  background: transparent;
  color: var(--auger-text-weak);
  cursor: pointer;
  font-size: 18px;

  &:hover {
    color: var(--auger-text);
    background: var(--auger-bg-muted);
  }
}
</style>
